import produce from 'immer';
import { LOGOUT_FULFILLED } from '../constants/actions/userProfileActions';
import IRecipientsReducer from '../interfaces/reducers/recipients';
import {
	CREATE_RECIPIENT_FAILED,
	CREATE_RECIPIENT_FULFILLED,
	CREATE_RECIPIENT_PENDING,
	FETCH_RECIPIENTS_FAILED,
	FETCH_RECIPIENTS_FULFILLED,
	FETCH_RECIPIENTS_PENDING,
} from './../constants/actions/recipientsActions';

const initialValues: IRecipientsReducer = {
	recipients: null,
	recipientsLoading: false,
	recipientsError: false,
};

const recipientsReducer = produce((draft: IRecipientsReducer, action) => {
	switch (action.type) {
		case FETCH_RECIPIENTS_PENDING: {
			draft.recipientsLoading = true;
			draft.recipientsError = false;
			break;
		}
		case FETCH_RECIPIENTS_FULFILLED: {
			draft.recipientsLoading = false;
			draft.recipients = action.payload;
			draft.recipientsError = false;
			break;
		}
		case FETCH_RECIPIENTS_FAILED: {
			draft.recipientsLoading = false;
			draft.recipientsError = true;
			break;
		}
		case CREATE_RECIPIENT_PENDING: {
			break;
		}
		case CREATE_RECIPIENT_FULFILLED: {
			draft.recipients = action.payload;
			break;
		}
		case CREATE_RECIPIENT_FAILED: {
			break;
		}
		case LOGOUT_FULFILLED: {
			draft.recipients = null;
			draft.recipientsLoading = false;
			draft.recipientsError = false;
			break;
		}
		default: {
			break;
		}
	}
}, initialValues);

export default recipientsReducer;
